module.exports = __webpack_public_path__ + "img/logo_new.b25b4a28.png";